/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Rearrangeable custom block inputs",
  "description": "Allows rearranging custom block parameters on the \"Make a block\" screen.",
  "credits": [
    {
      "name": "Chrome_Cat",
      "link": "https://scratch.mit.edu/users/Chrome_Cat/"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "arrows.css"
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "name": "Insert new inputs after selected input",
      "id": "InsertInputsAfter",
      "type": "boolean",
      "default": false
    }
  ],
  "tags": [
    "recommended"
  ],
  "enabledByDefault": true,
  "dynamicDisable": true
};
export default manifest;
